import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AVAILABILITY, JOBS } from "../graphQueries";
import { useEffect, useState } from "react";

const localizer = momentLocalizer(moment);

const EventCalendar = (props) => {
  const { handleChangeMenu, jobId } = props;
  const [eventsList, setEventsList] = useState([]);
  const [calendarHeight, setCalendarHeight] = useState(0);
  const [calendarWidth, setCalendarWidth] = useState(0);
  const [jobsList, setJobsList] = useState([]);

  useEffect(() => {
    availability();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setCalendarHeight(window.innerHeight - 90);
      setCalendarWidth(window.innerWidth - 40);
    };
    handleResize();
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Cleanup on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    console.log(eventsList);
  }, [eventsList]);

  const [availability] = useLazyQuery(AVAILABILITY, {
    fetchPolicy: "network-only",
    onCompleted: (result) => handleAvailability_Result(result),
    onError: (error) => handleAvailability_Error(error),
  });

  const handleAvailability_Result = (result) => {
    console.log(result);
    if (result && result.availability.length) {
      // build an events list here from the availability
      const datesArray = [];
      const upcomingDates = getUpcomingDates(365);
      for (const u of upcomingDates) {
        const daysArray = result.availability[0].days.split(",");
        for (const d of daysArray) {
          if (moment(u).format("ddd").includes(d)) {
            const obj = {
              title: "Available",
              start: combineDateAndTime(
                u,
                new Date(moment(result.availability[0].start).local())
              ),
              end: combineDateAndTime(
                u,
                new Date(moment(result.availability[0].end).local())
              ),
              type: "Availability",
              menu: "Availability",
            };
            datesArray.push(obj);
          }
        }
      }
      setEventsList(datesArray);
    }
    jobs();
  };
  const handleAvailability_Error = (error) => {
    console.log(error);
  };

  const getUpcomingDates = (days) => {
    return Array.from({ length: days }, (_, i) => {
      const date = new Date();
      date.setDate(date.getDate() + i);
      return date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    });
  };

  const combineDateAndTime = (dateObj, timeObj) => {
    // Create a new Date object from the date part
    const combined = new Date(dateObj);

    // Set the time part into the combined date object
    combined.setUTCHours(
      timeObj.getUTCHours(),
      timeObj.getUTCMinutes(),
      timeObj.getUTCSeconds(),
      timeObj.getUTCMilliseconds()
    );
    return combined;
  };

  const [jobs] = useLazyQuery(JOBS, {
    fetchPolicy: "network-only",
    onCompleted: (result) => handleJobs_Result(result),
    onError: (error) => handleJobs_Error(error),
  });

  const handleJobs_Result = (result) => {
    console.log(result);
    if (result && result.jobs) {
      setJobsList(result.jobs);
      let array = [...eventsList];
      for (const j of result.jobs) {
        const obj = {
          title: `${j.name}`,
          start: new Date(j.start),
          end: new Date(j.end),
          type: j.status,
          id: j.jobId,
          menu: "Jobs",
        };
        array.push(obj);
      }
      setEventsList(array);
    }
  };

  const handleJobs_Error = (error) => {
    console.log(error);
  };

  const eventStyleGetter = (event) => {
    switch (event.type) {
      case "Availability":
        return {
          style: {
            backgroundColor: "#999999",
          },
        };
      case "Requested":
        return {
          style: {
            backgroundColor: "#E07C32",
          },
        };
      case "Declined":
        return {
          style: {
            backgroundColor: "#C84232",
          },
        };
      case "Confirmed":
        return {
          style: {
            backgroundColor: "#4682CC",
          },
        };
      case "Completed":
        return {
          style: {
            backgroundColor: "#5BB750",
          },
        };
      default:
        return {};
    }
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={eventsList}
        startAccessor="start"
        endAccessor="end"
        eventPropGetter={eventStyleGetter}
        onSelectEvent={(e) => {
          handleChangeMenu(e.menu, null, e.id);
          console.log(e);
        }}
        style={{ height: calendarHeight, width: calendarWidth }}
      />
    </div>
  );
};

export default EventCalendar;
